export default {"src":"/_next/static/media/graphic5.5be5d11e.svg","height":160,"width":161,"blurWidth":0,"blurHeight":0};